const DLNT01V101 = async () => await import('@/views/external/DLNT-01-V101.vue')
const DLNT02V101 = async () => await import('@/views/external/DLNT-02-V101.vue')
const DLDS02P101 = async () => await import('@/views/external/DLDS-02-P101.vue')
const DWLOADLOGIN = async () => await import('@/views/external/DWLOAD-LOGIN.vue')
const DWLOADMAIN = async () => await import('@/views/external/DWLOAD-MAIN.vue')
const DWLOADAPP = async () => await import('@/views/external/DWLOAD-APP.vue')

export const routerExternal = [
  {
    path: '/external/DLNT-01-V101',
    component: DLNT01V101,
    name: 'DLNT-01-V101',
    meta: {
      header: {
        back: false,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '실시간 배송 위치',
      code: 'DLNT-01-V101',
      tabName: '마이페이지',
      requireAuth: false
    }
  },
  {
    path: '/external/DLNT-02-V101',
    component: DLNT02V101,
    name: 'DLNT-02-V101',
    meta: {
      header: {
        back: false,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '배송 사진',
      code: 'DLNT-02-V101',
      tabName: '배송 사진',
      requireAuth: false
    }
  },
  {
    path: '/external/DLDS-02-P101',
    component: DLDS02P101,
    name: 'DLDS-02-P101',
    meta: {
      header: {
        back: false,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '배송 접수증',
      code: 'DLDS-02-P101',
      tabName: '배송 접수증',
      requireAuth: false
    }
  },
  {
    path: '/external/DWLOAD-LOGIN',
    component: DWLOADLOGIN,
    name: 'dwload-login',
    meta: {
      header: null,
      code: 'dwload-login',
      tabName: '앱 다운로드 로그인',
      requireAuth: false
    }
  },
  {
    path: '/external/DWLOAD-MAIN',
    component: DWLOADMAIN,
    name: 'DWLOAD-MAIN',
    meta: {
      header: {
        back: false,
        myPage: false,
        refresh: false,
        home: false,
        type: 'appdown'
      },
      code: 'DWLOAD-MAIN',
      tabName: '앱 다운로드 메인',
      requireAuth: false
    }
  },
  {
    path: '/external/DWLOAD-APP',
    component: DWLOADAPP,
    name: 'DWLOAD-APP',
    meta: {
      header: null,
      code: 'DWLOAD-APP',
      tabName: '앱 다운로드 메인',
      requireAuth: false
    }
  }
]
